import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { MediaModel } from "../models";
import { MediaActions, MediaActionTypes } from "./media.actions";
import { createFeatureSelector } from "@ngrx/store";

export interface MediaState extends EntityState<MediaModel> {
	// additional entities state properties
	filesInUpload: { filename: string }[];
}

export const mediaAdapter: EntityAdapter<MediaModel> = createEntityAdapter<MediaModel>({
	selectId: (media: MediaModel) => media._id,
});

export const initialMediaState: MediaState = mediaAdapter.getInitialState({
	// additional entity state properties
	filesInUpload: [],
});

export const selectMediaState = createFeatureSelector<MediaState>("media");

export const {
	selectIds: selectMediaIds,
	selectEntities: selectMediaEntities,
	selectAll: selectAllMedia,
	selectTotal: selectMediaTotal,
} = mediaAdapter.getSelectors(selectMediaState);

export function reducer(state = initialMediaState, action: MediaActions): MediaState {
	switch (action.type) {
		case MediaActionTypes.AddMedia: {
			return mediaAdapter.addOne(action.payload.media, state);
		}

		case MediaActionTypes.UpdateMedia: {
			return mediaAdapter.updateOne(action.payload.media, state);
		}

		case MediaActionTypes.DeleteMediaFromStore:
		case MediaActionTypes.DeleteMedia: {
			return mediaAdapter.removeOne(action.payload.id, state);
		}

		case MediaActionTypes.LoadMedias: {
			return mediaAdapter.setAll(action.payload.medias, state);
		}

		case MediaActionTypes.ClearMedias: {
			return mediaAdapter.removeAll(state);
		}

		case MediaActionTypes.AddFileInUpload: {
			return {
				...state,
				filesInUpload: [...state.filesInUpload, { filename: action.payload.filename }],
			};
		}
		case MediaActionTypes.RemoveFileInUpload: {
			return {
				...state,
				filesInUpload: state.filesInUpload.filter(
					(file) => file.filename !== action.payload.filename
				),
			};
		}

		default: {
			return state;
		}
	}
}
